export class SettingDto {
  id?: number;             
  ttLogo?: string;
  practiceLogo?: string;
  legalName?: string;
  billingStreetAddress?: string;
  billingCity?: string;
  billingState?: string;
  billingCountry?: string;
  billingZipCode?: string;
  supportPhone?: string;
  supportEmail?: string;
}

export class TTKeyVaultSecrets
{
    pmsDataEncryptionKey?: string;
    clearentPaymentGatewayPublicKey?: string;
    pageIntegrityCheckEnabled?: boolean;
}